import Vue from 'vue';
import Posts from '../components/Posts';

export default () => {
  new Vue({
    data: {
      queryDataKey: 'post_filters',
      pushFilters: {},
      page: 1,
      filters: {
        keyword: null,
        category: 'none',
      }
    },
    components: {
      Posts
    },
    watch: {
      'filters.keyword': function(value) {
        if (value == '' || !value) {
          this.getItems();
        }
      }
    },
    methods: {
      getItems() {
        this.pushFilters = JSON.parse(JSON.stringify(this.filters));
        this.setUrlState();
      },

      setCategory(category) {
        if (this.filters.category == category) {
          this.filters.category = 'none';
        } else {
          this.filters.category = category;
        }

        this.getItems();
      },

      setUrlState() {
        let url = new URL(window.location.protocol + '//' + window.location.host + window.location.pathname);

        let params = new URLSearchParams(url.search.slice(1));
        let hasParams = false;

        if (this.filters.keyword) {
          params.append('keyword', encodeURIComponent(this.filters.keyword));
          hasParams = true;
        }

        if (this.filters.category !== 'none') {
          params.append('category', encodeURIComponent(this.filters.category));
          hasParams = true;
        }

        if (this.page > 1) {
          params.append('page', encodeURIComponent(this.page));
          hasParams = true;
        }

        if (params) {
          let newUrl = url + (hasParams ? '?' : '') + params;
          window.history.pushState({ path: newUrl }, '', newUrl);
        }
      },

      getUrlParam(key) {
        let url = new URL(window.location.href);

        return url.searchParams.get(key);
      },

      getFromParams(keyword, category, page) {
        if (keyword) {
          this.filters.keyword = decodeURIComponent(keyword);
        } else {
          this.filters.keyword = null
        }

        if (category) {
          this.filters.category = decodeURIComponent(category);
        } else {
          this.filters.category = 'none';
        }

        if (page) {
          this.page = parseInt(decodeURIComponent(page));
        } else {
          this.page = 1;
        }
      },

      getFromStorage(data) {
        let previousQuery = JSON.parse(data);

        if (previousQuery.keyword) {
          this.filters.keyword = previousQuery.keyword;
        }

        if (previousQuery.category) {
          this.filters.category = previousQuery.category;
        }

        if (previousQuery.page) {
          this.page = parseInt(previousQuery.page);
        }

        this.setUrlState();
      },

      itemsLoaded(data) {
        this.page = parseInt(data.current);
        this.setUrlState();
      }
    },

    created() {
      let queryKeyword = this.getUrlParam('keyword');
      let queryCategory = this.getUrlParam('category');
      let queryPage = this.getUrlParam('page');
      let previousQuery = sessionStorage.getItem(this.queryDataKey);

      if (queryKeyword || queryCategory || queryPage) {
        this.getFromParams(queryKeyword, queryCategory, queryPage);
      } else if (previousQuery) {
        this.getFromStorage(previousQuery);
      }

      window.onpopstate = () => {
        let queryKeyword = this.getUrlParam('keyword');
        let queryCategory = this.getUrlParam('category');
        let queryPage = this.getUrlParam('page');

        this.getFromParams(queryKeyword, queryCategory, queryPage);
      }

      this.getItems();
    }
  }).$mount('#vue__blog')
};



// WEBPACK FOOTER //
// ./resources/js/views/blog.js